import FilesOptionBar from './FilesOptionBar'

export default FilesOptionBar
